import moment from 'moment/moment';

export default {
  data() {
    return {
      form: {
        limit: 3,
        page: 1,
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    loading() {
      return this.$store.state.loading;
    },
    news() {
      const items = this.$store.state.news.news.map(el => ({
        ...el,
        translate_month: moment(el.created_at, 'DD.MM.YYYY')
          .locale('ru')
          .format('MMM'),
        translate_day: moment(el.created_at, 'DD.MM.YYYY').format('DD'),
      }));
      return items;
    },
    pagination() {
      return this.$store.state.news.pagination;
    },
  },
  methods: {
    getPublication(id) {
      this.$router.push(`/publication/${id}`);
    },
    GetNewsList() {
      this.$store.dispatch('news/GetNews', {
        profileId: this.user.profile_id,
        page: this.form.page,
      });
    },
    PageInput() {
      this.GetNewsList();
    },
  },

  created() {
    this.user.profile_id
      && this.$store.dispatch('news/GetNews', {
        profileId: this.user.profile_id,
        page: this.form.page,
      });
  },
  mounted() {
    this.$store.dispatch('SetTitle', 'Новости');
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
